import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import UnderstandPeopleMasterYourself from "./sections/UnderstandPeopleMasterYourself";
import LetsBuildSomethingTogether from "./sections/LetsBuildSomethingTogether";
import OurLocation from "./sections/OurLocation";
import SystemFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <UnderstandPeopleMasterYourself />
      <LetsBuildSomethingTogether />
      <OurLocation />
      <SystemFooter />
    </div>;
}